import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaAction, ISchemaFilter, ISchemaProperty } from "../Schema";
import { FilterTypes } from "../../../../enums/FilterTypes";
import { FilterMatchType } from "../../../../enums/FilterMatchType";
import { RelatedFilterValidation } from "../../../../enums/RelatedFilterValidation";
import { ContainersEntityTypes } from "../../../../enums/ContainersEntityTypes";
import SidePanelOuterCubes from "../../layout/SidePanel/layouts/SidePanelOuterCube";
import { EntityNames } from "../../../../enums/EntityNames";
import SidePanelPackingBox from "../../layout/SidePanel/layouts/SidePanelPackingBox";
import { ActionTypes } from "../../../../enums/ActionTypes";
import { ActionStyles } from "../../../../enums/ActionStyles";
import { ISelected } from "../../List/List";
import { hasPermission } from "../../../../modules/auth/Permissions/PermissionModule";
import { PermissionTypes, PermissionConcerns } from "../../../../modules/auth/Permissions/PermissionStrings";

export const ContainersSchema: ISchema = {
    displayName: "containers",
    GetSidePanelComponent: (data, onViewPage, entityName) =>
        entityName === EntityNames.outerCubes ? <SidePanelOuterCubes data={data} onViewPage={onViewPage} /> : <SidePanelPackingBox data={data} onViewPage={onViewPage} />,
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'reference',
            displayName: 'Reference',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'belongsTo',
            displayName: 'Belongs To',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'type',
            displayName: 'Type',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'resultType',
            displayName: 'Type',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'status',
            displayName: 'Status',
            type: PropertyTypes.status,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'currentLocation',
            displayName: 'Current Location',
            type: PropertyTypes.breadcrumb,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
    ],

    primaryFilter: {
        PropertyName: "Name",
        displayName: "Search",
        type: FilterTypes.search,
        required: false,
        className: "width--full",
        matchType: FilterMatchType.Equal,
        propertyType: PropertyTypes.string,
        placeHolder: "Enter an OC or PB reference"
    } as ISchemaFilter,

    filters: [
        {
            PropertyName: "BelongsToCellTrak",
            displayName: "Belongs to CellTrak",
            type: FilterTypes.toggle,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.belongsToCellTrak,
            onValue: true,
            offValue: undefined
        } as ISchemaFilter,
        {
            PropertyName: "Owner.AccountId",
            entityName: "accounts",
            displayName: "Account",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.uuid,
            relatedFilter: "BelongsToCellTrak",
            relatedFilterValidation: RelatedFilterValidation.MustNotHaveValue
        } as ISchemaFilter,
        {
            PropertyName: "Entity",
            displayName: "Container Type",
            type: FilterTypes.selectByEnum,
            enum: ContainersEntityTypes,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.entity,
        } as ISchemaFilter,
        {
            PropertyName: "Status",
            entityName: "containerStatuses",
            displayName: "Status",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.int,
        } as ISchemaFilter,
    ],

    listActions: [
        { 
            text: "Return Packing Boxes", 
            action: ActionTypes.returnPackingBoxes, 
            style: ActionStyles.secondary, 
            isEnabled: (selected: ISelected[]) => {
                return selected.every(x => x.entityName === EntityNames.packingBox);
            },
            permissionToView: (ctx) => hasPermission(ctx.permissions, PermissionTypes.write, PermissionConcerns.Return_Packing_Boxes)
        } as ISchemaAction,
    ]
}
